import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressBarDetails } from '../../api/models/ProgressBarDetails';
import { SessionResponse } from '../../api/models/SessionResponse';
import { RouteURLConstants } from '../../constants/upplm.constants';
import { UpsCommonService } from '../../services/upplm.common.service';
import { ProgressBarService } from '../../services/upplm.progressbar.service';
import { UpplmSessionService } from "../../services/upplm.session.service";

@Component({
    selector: 'upsProgressBar',
    template: require('./upsProgressBar.component.html'),
    styles: ['a{cursor:pointer} .ups-progress_complete{padding:2px 4px !important;} .ups-progress_number.ups-progress_current span{top: 0px !important;}']
})
export class upsProgressBarComponent implements OnInit {
    sessionData: SessionResponse;
    progressBar: ProgressBarDetails;
    locationPB: string = "";
    contactPB: string = "";
    placardPB: string = "";
    pickupPB: string = "";
    notificationPB: string = "";
    Errors: any[];
    ConfirmationBoxModal: any;

    constructor(private _sessionService: UpplmSessionService,
        private _commonService: UpsCommonService,
        private _pbService: ProgressBarService,
        private router: Router) { }

    ngOnInit() {
        this.setProgressBar();                
        if (this.progressBar) {
            this.bindDataFromSession(this.progressBar);            
        }        
    }

    setProgressBar() {
        this.progressBar = this._pbService.pb;
        if (this.progressBar == null || this.progressBar == undefined) {
            this.locationPB = "false";
            this.contactPB = "false";
            this.placardPB = "false";
            this.pickupPB = "false";
            this.notificationPB = "false";
        } else {
            this.locationPB = this.progressBar.locationPB;
            this.contactPB = this.progressBar.contactPB;
            this.placardPB = this.progressBar.placardPB;
            this.pickupPB = this.progressBar.pickupPB;
            this.notificationPB = this.progressBar.notificationPB;
        }
    }

    bindDataFromSession(data: ProgressBarDetails) {
        this.locationPB = data.locationPB;
        this.contactPB = data.contactPB;
        this.placardPB = data.placardPB;
        this.pickupPB = data.pickupPB;
        this.notificationPB = data.notificationPB;
    }

    gotoLocation() {
        this._pbService.pb = new ProgressBarDetails();
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_LOCATIONS_DETAILS_ROUTE);   
    }

    gotoContact() {
        this.progressBar = new ProgressBarDetails();
        this.progressBar.locationPB = "true";
        this._pbService.pb = this.progressBar;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_CONTACT_DETAILS_ROUTE);   
    }

    gotoPlacard() {
        this.progressBar = new ProgressBarDetails();
        this.progressBar.locationPB = "true";
        this.progressBar.contactPB = "true";
        this._pbService.pb = this.progressBar;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_DETAILS_ROUTE);   
    }

    gotoPickup() {
        this.progressBar = new ProgressBarDetails();
        this.progressBar.locationPB = "true";
        this.progressBar.contactPB = "true";
        this.progressBar.placardPB = "true";
        this._pbService.pb = this.progressBar;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PICKUP_DETAILS_ROUTE);   
    }

    gotoNotification() {
        this.progressBar = new ProgressBarDetails();
        this.progressBar.locationPB = "true";
        this.progressBar.contactPB = "true";
        this.progressBar.placardPB = "true";
        this.progressBar.pickupPB = "true";
        this._pbService.pb = this.progressBar;
        this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_NOTIFICATION_DETAILS_ROUTE);   
    }

    validateSessionAndNavigate(target: string) {
        if (!this._sessionService.isValidSession()) {
            this._pbService.pb = new ProgressBarDetails();
            this.ConfirmationBoxModal.open();
        }
        else {
            this.router.navigateByUrl(target);
        }
    }
}
